import { MAX_IMAGE_ATTACH_PAYLOAD_SIZE } from '@shared/utils/max-image-attach-payload-size';
import { isVideoFile } from './is-video-file';

// Videos are excluded: they are uploaded chunk by chunk through the video controller, so they
// never weigh on the attachSequenceMedia payload.
export const isImagePayloadTooLarge = (files: File[]): boolean =>
  files.filter((file) => !isVideoFile(file)).reduce((totalSize, file) => totalSize + file.size, 0) >
  MAX_IMAGE_ATTACH_PAYLOAD_SIZE;
